<template>
  <Widget
    title="SOLICITUDES"
    title-link="/page/requests/list"
    actionLabel="CREAR"
    :indicators="indicators"
    @action="action"
  />
  <modal-select-product-type
    v-model="modalVisible"
    title="Nueva solicitud"
    url="/page/requests/edit"
    @close-modal="() => (modalVisible = false)"
  />
</template>

<script setup>
import {
  ref,
  onMounted,
} from 'vue';
import useApi from '@/shared/composables/useApi';
import ModalSelectProductType from '@/shared/components/modal_select_product_type.vue';
import Widget from './base/indicator.vue';

const { apiGet } = useApi();
const modalVisible = ref(false);

function action() {
  modalVisible.value = true;
}

const indicators = ref([]);

const fetchData = async () => {
  const result = await apiGet('/dashboard/solicitudes');
  indicators.value = result.data;
};

onMounted(() => {
  fetchData();
});
</script>

<style scoped>
.widget-card {
  margin: 10px;
}

.indicator {
  margin-top: 2rem;
  margin-bottom: 0.5rem;
}

.label {
  font-weight: 600;
}

.value {
  text-align: right;
  /* Alinea el valor a la derecha */
  /* font-size: 1.2em; */
}
</style>
